module.exports = __webpack_public_path__ + "static/home-banner1-d0013b29a7e9c01517e59a6a48e1fd55.png";